import { Injectable } from '@angular/core';
import {
  HttpClient,
  HttpParams
} from '@angular/common/http';

import { environment } from '../../environments/environment';
import { Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class CheckpointsService {

  private endpoint = `${environment.apiBase}/checkpoints`;

  constructor(private http: HttpClient) {}

  list(
    startDate?: string,
    endDate?: string
  ): Observable<any[]> {

    let params = new HttpParams();

    if (startDate) {
      params = params.set('startDate', startDate);
    }

    if (endDate) {
      params = params.set('endDate', endDate);
    }

    return this.http.get<any[]>(
      this.endpoint,
      { params }
    );
  }

  downloadExcelPorMaster(masterId: number): Observable<Blob> {

    const url =
      `${environment.apiBase}/download-excel/master/${masterId}`;

    return this.http.get(
      url,
      { responseType: 'blob' }
    );
  }
}